import React from "react";
import {
  Card,
  DisplayText,
  SkeletonBodyText,
  TextStyle,
} from "@shopify/polaris";
import currencySymbol from "currency-symbol-map";
import Br from "../../components/Br";

const DashboardDetails = ({ loading, currency, dashboardData = {} , width=50}) => {
  let defaultData = {
    totalRecoveredCheckouts: "N/A",
    totalAbandonedRevenue: "N/A",
    totalRecoveredRevenue: "N/A",
    totalAbandonedCheckouts: "N/A",
  };
  let data = { ...defaultData, ...dashboardData };
  return (
    <div style={{ width: width+"%", paddingBottom: "20px" }}>
      <div
        style={{
          gridTemplateColumns: "auto auto",
          display: "grid",
          gridGap: "30px;",
        }}
      >
        <div style={{ padding: "20px 0px 20px 0px" }} class="grid-item">
          <Card title="" sectioned>
            <DisplayText size="medium">
              {" "}
              {loading && <SkeletonBodyText lines={2} />}
              {!loading && (
                <div style={{ minWidth: "120px" }}>
                  {parseFloat(data.totalAbandonedRevenue) > 0
                    ? currencySymbol(currency) +
                      " " +
                      parseFloat(data.totalAbandonedRevenue).toFixed(2)
                    : "N/A"}
                </div>
              )}
            </DisplayText>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "70px",
              }}
            >
              <div>
                <Br height={20} />
                <TextStyle variation="subdued">Abandoned</TextStyle>
                <br />
                <TextStyle variation="subdued">Revenue</TextStyle>
              </div>

              <div style={{ textAlign: "right" }}>
                <img
                  style={{ paddingTop: "10%", transform: "scale(0.6)" }}
                  alt=""
                  width="50%"
                  src="../../Assets/widget/abandoned -revenue.png"
                />
              </div>
            </div>
          </Card>
        </div>
        <div style={{ padding: "20px 0px 20px 20px" }} class="grid-item">
          <Card title="" sectioned>
            <DisplayText size="medium">
              {loading && <SkeletonBodyText lines={2} />}
              {!loading && (
                <>
                  {parseInt(data.totalAbandonedCheckouts) > 0
                    ? data.totalAbandonedCheckouts
                    : "N/A"}
                </>
              )}
            </DisplayText>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "70px",
              }}
            >
              <div>
                <Br height={20} />
                <TextStyle variation="subdued">Abandoned</TextStyle>
                <br />
                <TextStyle variation="subdued">Checkouts</TextStyle>
              </div>
              <div style={{ textAlign: "right" }}>
                <img
                  style={{ paddingTop: "10%", transform: "scale(0.6)" }}
                  alt=""
                  width="50%"
                  src="../../Assets/widget/abandoned-checkouts.png"
                />
              </div>
            </div>
          </Card>
        </div>
        <div style={{ paddingBottom: "20px" }} class="grid-item">
          <Card title="" sectioned>
            <DisplayText size="medium">
              {loading && <SkeletonBodyText lines={2} />}
              {!loading && (
                <>
                  {parseFloat(data.totalRecoveredRevenue) > 0
                    ? currencySymbol(currency) +
                      " " +
                      parseFloat(data.totalRecoveredRevenue).toFixed(2)
                    : "N/A"}
                </>
              )}
            </DisplayText>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "70px",
              }}
            >
              <div>
                <Br height={20} />
                <TextStyle variation="subdued">Recovered</TextStyle>
                <br />
                <TextStyle variation="subdued">Revenue</TextStyle>
              </div>
              <div style={{ textAlign: "right" }}>
                <img
                  style={{ paddingTop: "10%", transform: "scale(0.6)" }}
                  alt=""
                  width="50%"
                  src="../../Assets/widget/recovered-revenue.png"
                />
              </div>
            </div>
          </Card>
        </div>
        <div style={{ padding: "0px 0px 20px 20px" }} class="grid-item">
          <Card title="" sectioned>
            <DisplayText size="medium">
              {loading && <SkeletonBodyText lines={2} />}
              {!loading && (
                <>
                  {parseInt(data.totalRecoveredCheckouts) > 0
                    ? data.totalRecoveredCheckouts
                    : "N/A"}
                </>
              )}
            </DisplayText>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                height: "70px",
              }}
            >
              <div>
                <Br height={20} />
                <TextStyle variation="subdued">Recovered</TextStyle>
                <br />
                <TextStyle variation="subdued">Checkouts</TextStyle>
              </div>
              <div style={{ textAlign: "right" }}>
                <img
                  style={{ paddingTop: "10%", transform: "scale(0.6)" }}
                  alt=""
                  width="50%"
                  src="../../Assets/widget/recovered -checkouts.png"
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DashboardDetails;
